import STORE from 'store';

const archiveDashboard = (id: string, accountId: string): Promise<void> => {
  return STORE.getDashboardsRef({ accountId })
    .doc(id)
    .update({ isHidden: true });
};

export default archiveDashboard;
